// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style, func-names, init-declarations, babel/camelcase */
import immutable from "immutable"
import moment from "moment"
import * as R from "ramda"

import { get, getOr } from "../../utils/get"
import has from "../../utils/has"
import { mapToUtcMoment } from "../momentHelpers/momentHelpers"
import cuckoo from "../cuckoo/cuckoo"
import Flight from "../../records/Flight"
import { cuckooEvents } from "../../consts/enums"
import { RESERVATION_PART_CONFIG } from "../../consts/booking"
import { HIDING_REASON_TYPES } from "../../consts/journey"

/*
API Endpoints

(A) /check_flights
(B) /api/v0.1/users/self/bookings
(C) /flights
*/

export function mapFlightDateTimes(flightObj) {
  if (has("dtime", flightObj) && has("atime", flightObj)) {
    // (A)
    return {
      departureWhen: {
        local: moment.utc(flightObj.dtime * 1000),
        utc: moment.utc(flightObj.dtime_utc * 1000),
      },
      arrivalWhen: {
        local: moment.utc(flightObj.atime * 1000),
        utc: moment.utc(flightObj.atime_utc * 1000),
      },
    }
  }

  if (has("departure.when.local", flightObj) && has("arrival.when.local", flightObj)) {
    // (B)
    return {
      departureWhen: {
        local: mapToUtcMoment(flightObj.departure.when.local),
        utc: mapToUtcMoment(flightObj.departure.when.utc),
      },
      arrivalWhen: {
        local: mapToUtcMoment(flightObj.arrival.when.local),
        utc: mapToUtcMoment(flightObj.arrival.when.utc),
      },
    }
  }

  if (has("dTime", flightObj) && has("aTime", flightObj)) {
    // (C)
    return {
      departureWhen: {
        local: moment.utc(flightObj.dTime * 1000),
        utc: moment.utc(flightObj.dTimeUTC * 1000),
      },
      arrivalWhen: {
        local: moment.utc(flightObj.aTime * 1000),
        utc: moment.utc(flightObj.aTimeUTC * 1000),
      },
    }
  }

  cuckoo.error(cuckooEvents.INTERNAL_MAPPER_FLIGHT_UNSUPPORTED_FORMAT_TIME, {
    input: flightObj,
  })

  return {}
}

export default function (flightObj, passengersObj, airlines) {
  // Search API format:          "vehicle_type": "train" | "aircraft"
  // Check flights | MMB format: ["vehicle"]["type"]: "train" | "aircraft"
  const vehicleType =
    get(["vehicle", "type"], flightObj) || get("vehicle_type", flightObj) || "flight"

  const flightType =
    vehicleType === "aircraft" || vehicleType === "airline" ? "flight" : vehicleType
  let departureWhere
  let arrivalWhere
  if (has("src", flightObj) && has("dst", flightObj)) {
    // (A)
    departureWhere = {
      code: flightObj.src, // STN
      name: flightObj.src_name, // London
      nameOriginal: flightObj.src_name_original || flightObj.src_name, // London
      city: flightObj.src_city, // london_gb
      country: flightObj.src_country, // GB
      terminal: flightObj.src_terminal, // A
      station: flightObj.src_station,
      locationId: flightObj.src_location_id,
      locationType: flightObj.src_location_type,
      region: flightObj.src_region,
      continent: flightObj.src_continent,
      nameEnglish: flightObj.src_name_english,
      regionEnglish: flightObj.src_region_english,
      continentEnglish: flightObj.src_continent_english,
      // src_id // 813
    }
    arrivalWhere = {
      code: flightObj.dst,
      name: flightObj.dst_name,
      nameOriginal: flightObj.dst_name_original || flightObj.dst_name,
      city: flightObj.dst_city,
      country: flightObj.dst_country,
      terminal: flightObj.dst_terminal,
      station: flightObj.dst_station,
      locationId: flightObj.dst_location_id,
      locationType: flightObj.dst_location_type,
      region: flightObj.dst_region,
      continent: flightObj.dst_continent,
      nameEnglish: flightObj.dst_name_english,
      regionEnglish: flightObj.dst_region_english,
      continentEnglish: flightObj.dst_continent_english,
    }
  } else if (has("departure.where.code", flightObj) && has("arrival.where.code", flightObj)) {
    // (B)
    departureWhere = {
      code: flightObj.departure.where.code,
      name: flightObj.departure.where.name,
      city: flightObj.departure.where.city_id,
      country: flightObj.departure.where.country,
      terminal: flightObj.departure.where.terminal,
      station: flightObj.departure.where.station,
    }
    arrivalWhere = {
      code: flightObj.arrival.where.code,
      name: flightObj.arrival.where.name,
      city: flightObj.arrival.where.city_id,
      country: flightObj.arrival.where.country,
      terminal: flightObj.arrival.where.terminal,
      station: flightObj.arrival.where.station,
    }
  } else if (has("flyFrom", flightObj) && has("flyTo", flightObj)) {
    // (C)
    // noinspection SpellCheckingInspection
    departureWhere = {
      id: flightObj.mapIdfrom,
      code: flightObj.flyFrom,
      name: flightObj.cityFrom,
      lat: flightObj.latFrom,
      lng: flightObj.lngFrom,
      station: flightObj.stationFrom,
      // TODO: Add terminals
    }
    // noinspection SpellCheckingInspection
    arrivalWhere = {
      id: flightObj.mapIdto,
      code: flightObj.flyTo,
      name: flightObj.cityTo,
      lat: flightObj.latTo,
      lng: flightObj.lngTo,
      station: flightObj.stationTo,
      // TODO: Add terminals
    }
  } else {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_FLIGHT_UNSUPPORTED_FORMAT_LOCATION, {
      input: flightObj,
    })
  }

  const { departureWhen, arrivalWhen } = mapFlightDateTimes(flightObj)

  let airlineCode
  if (has("airline.iata", flightObj)) {
    airlineCode = flightObj.airline.iata
  } else if (typeof flightObj.airline === "string") {
    airlineCode = flightObj.airline
  } else {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_FLIGHT_UNSUPPORTED_FORMAT_AIRLINE, {
      input: flightObj,
    })
  }

  // Hide the name of the carrier (used on Booking)
  const hideAirlineName = flightObj.airline?.hide_name || false
  const hideOperatingAirlineName = flightObj.operating_airline?.hide_name || false

  const airline = {
    code: airlineCode,
    name: hideAirlineName ? airlineCode : get([airlineCode, "name"], airlines),
    logo: getOr(RESERVATION_PART_CONFIG[flightType].logo, [airlineCode, "logo"], airlines),
    closeBookingHours: get(["airline", "close_booking_hours"], flightObj), // only from check_flights api call
    hasHiddenName: hideAirlineName,
  }

  const operatingAirline = flightObj.operating_airline
    ? immutable.fromJS({
        code: flightObj.operating_airline.iata,
        name: hideOperatingAirlineName
          ? flightObj.operating_airline.iata
          : flightObj.operating_airline.name,
        logo: getOr(
          RESERVATION_PART_CONFIG[flightType].logo,
          [flightObj.operating_airline.iata, "logo"],
          airlines,
        ),
        hasHiddenName: hideOperatingAirlineName,
      })
    : null

  const returnFareCategory = (type, vehicle) =>
    R.isEmpty(type) || (R.isNil(type) && vehicle === "aircraft") ? "M" : type

  const priorityBoardingForEachPassenger =
    passengersObj &&
    R.values(passengersObj).every((passengerObj) =>
      getOr(false, ["priority_boarding", flightObj.id, "is_ordered"], passengerObj),
    )
  return new Flight({
    id: flightObj.id,
    combinationId: flightObj.combination_id,
    number: flightObj.flight_no,
    segmentCode: flightObj.carrier_segment_code || null,
    pnr: flightObj.reservation_number,
    bagsRecheckRequired: Boolean(flightObj.bags_recheck_required),
    guarantee: flightObj.guarantee,
    isSelfTransfer: Boolean(flightObj.is_self_transfer ?? flightObj.guarantee),
    priorityBoarding: flightObj.forced_priority_boarding || priorityBoardingForEachPassenger, // derived from passengersObj for MMB
    isCabinBagsWithPriorityBoarding: flightObj.is_cabin_bags_with_priority_boarding || false,
    seatmap: null, // not available yet, will be returned from different API

    // TODO thing about use of Place and TimeInPlace objects
    departure: immutable.fromJS({
      where: departureWhere,
      when: departureWhen,
    }),
    arrival: immutable.fromJS({
      where: arrivalWhere,
      when: arrivalWhen,
    }),
    airline: immutable.fromJS(airline),
    vehicle: flightObj.vehicle && immutable.fromJS(flightObj.vehicle),
    operatingAirline,
    type: flightType,
    isThrowawayTicket: flightObj.hiding_reason === HIDING_REASON_TYPES.TAT,
    isHiddenCity: flightObj.hiding_reason === HIDING_REASON_TYPES.THC,
    fareCategory: returnFareCategory(flightObj.fare_category, flightObj.vehicle?.type),
    segment_pricing: flightObj.segment_pricing,
  })
}
